import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const CloseIcon = ({ viewBox, stroke, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 16 16'}>
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="#2B3D50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5291 5.46898C10.6268 5.56661 10.6268 5.7249 10.5291 5.82253L5.82326 10.5284C5.72563 10.626 5.56734 10.626 5.46971 10.5284C5.37208 10.4308 5.37208 10.2725 5.46971 10.1749L10.1756 5.46898C10.2732 5.37134 10.4315 5.37134 10.5291 5.46898Z"
      fill="#2B3D50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.47086 5.46898C5.37323 5.56661 5.37323 5.7249 5.47086 5.82253L10.1767 10.5284C10.2744 10.626 10.4327 10.626 10.5303 10.5284C10.6279 10.4308 10.6279 10.2725 10.5303 10.1749L5.82441 5.46898C5.72678 5.37134 5.56849 5.37134 5.47086 5.46898Z"
      fill="#2B3D50"
    />
  </BaseIcon>
);

export default CloseIcon;
